<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex flex-col sm:flex-row justify-between my-3 gap-3">
  <h2>Other Bookings</h2>
  <button *appHasAnyPrivilege="'OTHER_BOOKING_CREATE'" nz-button nzType="primary"
          routerLink="/admin/booking-other/add-edit" (click)="navigateNewOtherBooking()">Add New Other Booking
  </button>
</div>

<section class="my-3">

  <nz-card>
    <div class="flex flex-col gap-3">
      <div [ngClass]="loading ? 'hidden' : 'block'">
        <nz-collapse>
          <nz-collapse-panel [nzHeader]="'Advanced Search'">
            <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center md:items-end gap-4">
              <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton" style="width: auto">
                  <input type="text" (keydown.enter)="search()" [(ngModel)]="searchText" nz-input
                         placeholder="Search here"/>
                </nz-input-group>

                <ng-template #suffixIconSearchButton>
                  <button nz-button nzType="primary" nzSearch (click)="search()" class="bg-[#6B6C6E] border-[#6B6C6E]">
                    <span nz-icon nzType="search"></span>
                  </button>
                </ng-template>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"></nz-divider>

                <div class="flex xl:w-auto  flex-col lg:flex-row lg:items-center">
                  <div>
                    <nz-form-label class="flex">Filter By Status</nz-form-label>
                  </div>

                  <div class="w-full">
                    <nz-select
                      [(ngModel)]="statusFilter"
                      (ngModelChange)="search()"
                      nzPlaceHolder="Select Status"
                      [nzAllowClear]="true"
                      class="w-full"
                    >
                      <nz-option nzLabel="Reservation" nzValue="RESERVATION"></nz-option>
                      <nz-option nzLabel="On Other Tour" nzValue="ON_OTHER_TOUR"></nz-option>
                      <nz-option nzLabel="Completed" nzValue="COMPLETED"></nz-option>
                      <nz-option nzLabel="Cancelled" nzValue="CANCELLED"></nz-option>
                    </nz-select>
                  </div>
                </div>
                <div>
                  <nz-divider
                    class="hidden lg:block"
                    [nzType]="'vertical'"
                  ></nz-divider>
                </div>
                <nz-range-picker [(ngModel)]="dateFilter"
                                 (ngModelChange)="onChangeDateFilter($event)"></nz-range-picker>
              </div>
              <div>
                <button nz-button nzBlock class="outline-button" (click)="resetSearch()">
                  Reset All
                </button>
              </div>
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>

      <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
        <div class="table-obj">
          <nz-table
            #basicTable [nzData]="otherReservationData" [nzShowSizeChanger]="pageSize.length > 5"
            [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
            [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
            (nzQueryParams)="onTableParamsChange($event)" nzTableLayout="fixed" [nzScroll]="{ x: 'auto',y: '550px'}"
            nzOuterBordered 
          >
            <thead>
            <tr>
              <th>Booking ID</th>
              <th>Reason</th>
              <th>Number of Days</th>
              <th>Start Date and Time</th>
              <th>End Date and Time</th>
              <th>Vehicle category</th>
              <th>Allocated vehicle reg. No</th>
              <th>Status</th>
              <th>
                <span>Created Date</span>
                <span *ngIf="sortOrder === -1" nz-icon nzType="up" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
                <span *ngIf="sortOrder === 1" nz-icon nzType="down" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span></th>
              <th *appHasAnyPrivilege="'OTHER_BOOKING_UPDATE,OTHER_BOOKING_SINGLE_VIEW'">Actions</th>
            </tr>

            </thead>
            <tbody>

            <tr *ngFor="let data of basicTable.data" class="align-baseline">
              <td style="min-width:120px;">
                <a *appHasAnyPrivilege="'OTHER_BOOKING_SINGLE_VIEW'" (click)="navigateToSingle(data._id)"
                   class="clickable-text">{{ data.otherBookingId }}</a>
                <span *ngIf="!hasPermission('OTHER_BOOKING_SINGLE_VIEW')">{{ data.otherBookingId }}</span>
              </td>
              <td style="min-width:120px; white-space: nowrap">{{ data.reservationDetails.reason }}</td>
              <td style="min-width:180px;">{{ data.reservationDetails.noOfDays }}</td>
              <td style="min-width:180px; white-space: nowrap">{{ (data.reservationDetails.arrivalDate | date:'yyyy-MM-dd') + ' | ' + (data.reservationDetails.arrivalTime | date:'hh:mm a') }}</td>
              <td style="min-width:180px; white-space: nowrap">{{ (data.reservationDetails.departureDate | date:'yyyy-MM-dd') + ' | ' + (data.reservationDetails.departureTime | date:'HH:mm a') }}</td>
              <td style="min-width:200px;">{{ data.allocationDetails.vehicleCategory ? data.allocationDetails.vehicleCategory.name : '-' }}</td>
              <td style="min-width:200px;">{{ data.allocationDetails.allocatedVehicle ? data.allocationDetails.allocatedVehicle.refNo : '-' }}</td>
              <td style="min-width:120px;">
                <nz-tag *ngIf="data?.status === 'COMPLETED'" [nzColor]="'#3ab200'"
                        class="rounded-full"
                >Completed
                </nz-tag
                >
                <nz-tag
                  *ngIf="data?.status === 'CANCELLED'" class="rounded-full" [nzColor]="'#F3454C'"
                >Cancelled
                </nz-tag>
                <nz-tag
                  *ngIf="data?.status === 'RESERVATION'"
                  [nzColor]="'#FF8C00'" class="rounded-full"
                >Reservation
                </nz-tag>
                <nz-tag
                  *ngIf="data?.status === 'ON_OTHER_TOUR'"
                  [nzColor]="'#4655f5'" class="rounded-full"
                >On Other Tour
                </nz-tag>
              </td>
              <td style="min-width:150px;">{{ data?.createdAt | date: 'dd-MM-y' }}</td>
              <td style="min-width:150px;" *appHasAnyPrivilege="'OTHER_BOOKING_CHANGE_STATUS,OTHER_BOOKING_UPDATE,OTHER_BOOKING_SINGLE_VIEW'">
                <button *appHasAnyPrivilege="'OTHER_BOOKING_UPDATE'" class="outline-button mr-3" nz-button
                        nzType="default" (click)="editNavigate(this.data._id)">Edit
                </button>
                <button *appHasAnyPrivilege="'OTHER_BOOKING_CHANGE_STATUS,OTHER_BOOKING_SINGLE_VIEW'"
                        class="outline-button more-dropdown"
                        nz-button
                        nz-dropdown
                        [nzDropdownMenu]="menu"
                        nzPlacement="bottomCenter"
                >
                  <span nz-icon nzType="more" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li *appHasAnyPrivilege="'OTHER_BOOKING_SINGLE_VIEW'" nz-menu-item nz-popconfirm nz-button
                        (click)="navigateToSingle(data._id)">View
                    </li>
                    <span *ngIf="data?.status !== 'COMPLETED'">
                    <li *appHasAnyPrivilege="'OTHER_BOOKING_CHANGE_STATUS'" nz-submenu nzTitle="Change Status">
                      <ul>
                        <li nz-menu-item nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want change the status to Reservation?"
                            *ngIf="
                                data?.status === 'CANCELLED'
                              "
                            [nzOkText]="'Yes'" [nzCancelText]="'No'"
                            (nzOnCancel)="handleCancelSelectStatus()"
                            (nzOnConfirm)="handleOkSelectStatus('RESERVATION', data)">Reservation
                        </li>
                        <li nz-menu-item nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want change the status to On Other Tour?"
                            *ngIf="
                                data?.status === 'RESERVATION'
                              "
                            [nzOkText]="'Yes'" [nzCancelText]="'No'"
                            (nzOnCancel)="handleCancelSelectStatus()"
                            (nzOnConfirm)="handleOkSelectStatus('ON_OTHER_TOUR', data)">On Other Tour
                        </li>
                        <li nz-menu-item nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want change the status to Completed?"
                            *ngIf="
                                data?.status === 'ON_OTHER_TOUR'
                              "
                            [nzOkText]="'Yes'" [nzCancelText]="'No'"
                            (nzOnCancel)="handleCancelSelectStatus()"
                            (nzOnConfirm)="handleOkSelectStatus('COMPLETED', data)">Completed
                        </li>
                        <li nz-menu-item nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want change the status to Cancelled?"
                            *ngIf="
                                data?.status === 'ON_OTHER_TOUR' ||
                                data?.status === 'RESERVATION'
                              "
                            [nzOkText]="'Yes'" [nzCancelText]="'No'"
                            (nzOnCancel)="handleCancelSelectStatus()"
                            (nzOnConfirm)="handleOkSelectStatus('CANCELLED', data)">Cancelled
                        </li>
                      </ul>
                    </li>
                    </span>

                  </ul>
                </nz-dropdown-menu>
              </td>
            </tr>

            </tbody>
          </nz-table>
        </div>
      </div>
      <div [ngClass]="loading ? 'block' : 'hidden'">
        <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
      </div>

    </div>
  </nz-card>
</section>

<nz-modal
  [(nzVisible)]="isVisibleFuelAndMileageUpdate"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
>
  <ng-template
    #modalTitle>{{ changingStatus === 'CANCELLED' ? 'Reason for Cancellation' : 'Current Fuel and Mileage Update' }}
  </ng-template>

  <ng-template #modalContent>
    <div *ngIf="changingStatus === 'ON_OTHER_TOUR' || changingStatus === 'COMPLETED'" class="flex flex-col gap-4">
      <p class="font-bold">{{ changingStatus === 'ON_OTHER_TOUR' ? 'Start' : 'End' }} Mileage :</p>
      <nz-input-group nzAddOnAfter="Km">
        <input nz-input type="number" [min]="0" [step]="1" [(ngModel)]="mileage" placeholder="Enter Mileage"/>
      </nz-input-group>

      <p class="font-bold">{{ changingStatus === 'ON_OTHER_TOUR' ? 'Start' : 'End' }} Fuel Level :</p>
      <nz-input-group nzAddOnAfter="%">
        <input nz-input type="number" [min]="0" [max]="100" [step]="1" [(ngModel)]="fuelLevel" placeholder="Enter Fuel Level"/>
      </nz-input-group>
    </div>

    <div *ngIf="changingStatus === 'CANCELLED'" class="flex flex-col">
      <p class="font-bold">Reason to Cancel :</p>
      <nz-select class="w-full" [(ngModel)]="cancelReason" nzPlaceHolder="Select Preference"
                 nzShowSearch nzAllowClear [nzDropdownRender]="renderTemplate">
        <nz-option *ngFor="let item of cancelReasonOptions" [nzLabel]="item" [nzValue]="item"></nz-option>
      </nz-select>
      <ng-template #renderTemplate>
        <nz-divider></nz-divider>
        <div class="flex flex-col justify-center mx-3">
          <input type="text" nz-input #inputElement/>
          <a class="text-center m-1" (click)="addItem(inputElement)">
            <span nz-icon nzType="plus"></span>
            Add item
          </a>
        </div>
      </ng-template>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancelUpdateFuelAndMileage()">Cancel</button>
    <button *ngIf="!(changingStatus === 'CANCELLED')" nz-button nzType="primary"
            [disabled]="(fuelLevel === 0 || undefined) || (mileage === 0 || undefined)"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to save this information and change the status?"
            [nzOkText]="'Yes'" [nzCancelText]="'No'"
            (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
            (nzOnConfirm)="handleOkUpdateFuelAndMileage()" [nzLoading]="isLoading">Save
    </button>
    <button *ngIf="changingStatus === 'CANCELLED'" nz-button nzType="primary" [disabled]="(cancelReason === null)"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to save this information and change the status?"
            [nzOkText]="'Yes'" [nzCancelText]="'No'"
            (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
            (nzOnConfirm)="handleOkCancelledStatus()" [nzLoading]="isLoading">Save
    </button>
  </ng-template>
</nz-modal>
